import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rIstatistikSonuc_1, rValue } from '../../models/.catalog';

export default class KullanimAmacliGayrimenkulAlanApi extends ApiBase<
  pList,
  rValue<rIstatistikSonuc_1>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/KullanimAmacliGayrimenkulAlan',
      }),
      options
    );
  }
}
